/* @flow */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Experiment, Variant, emitter, experimentDebugger } from 'react-ab-test';
import { getSearchParam } from 'depop/utils/url';
import { trackShowAB, trackActionAB } from 'depop/utils/tracking';
import { updateLandingAB } from 'depop/state/overlays';
import DeeplinkConfig from 'depop/components/deeplinks/DeeplinkConfig';
import { config } from 'depop/config';
import HomeHeader from './HomeHeader';

const noTrackVariant = 'NX';

const createTrackingObject = (experimentName, variantName) => ({ testId: experimentName, variantId: variantName });
const filteredRun = (callback) => (experimentName, variantName) => (variantName !== noTrackVariant) ? callback(experimentName, variantName) : ()=>null;

const trackExperimentShow = (experimentName, variantName) => trackShowAB({ testId: experimentName, variantId: variantName });
const trackExperimentWin = (experimentName, variantName, buttonName) => trackActionAB({ testId: experimentName, variantId: variantName, button: buttonName });

export const emmitButtonClick = function (experimentName, buttonName) {
  if (!experimentName || !buttonName) { return false }
  const variantId = emitter.getActiveVariant(experimentName);

  if (!variantId) {
    return false;
  }

  trackExperimentWin(experimentName, variantId, buttonName);
}

export const initExperiment = function (experimentName) {
  // emitter.defineVariants(experimentName, ['A', 'B'], [50, 50]);
  emitter.defineVariants(experimentName, ['A', 'B'], [0, 100]);
  // Called when the experiment is displayed to the user.
  emitter.addPlayListener(experimentName, filteredRun(trackExperimentShow));

  const userSetVariant = getSearchParam('variant');
  if (userSetVariant) {
    console.log('Setting variant to: ', userSetVariant);
    emitter.setActiveVariant(experimentName, userSetVariant);
  }

  if (__DEV__) {
    experimentDebugger.enable();
  }
}


class HomeAB extends React.Component {

  propTypes: {
    abId: PropTypes.string.isRequired
  }

  componentWillUnmount () {
    const { updateAB } = this.props;
    updateAB();
  }

  componentDidMount () {
    const { experiment, updateAB } = this.props;
    const variantId = emitter.getActiveVariant(experiment);
    updateAB(variantId);
  }

  onStoreButtonClick (store) {
    const { experiment } = this.props;
    emmitButtonClick(experiment, store || 'app store');
    this.refs.experiment.win();
  }

  render () {
    const { children, experiment, abId, ...props } = this.props;
    const token = abId;
    const onStoreButtonClick = this.onStoreButtonClick.bind(this);

    return (
      <Experiment ref="experiment" name={experiment} userIdentifier={token}>
        <Variant name="A">
          <DeeplinkConfig
            path="explore"
            referer={`${experiment}_A`}
            canonicalUrl="https://www.depop.com/"
          />
        </Variant>
        <Variant name="B">
          <DeeplinkConfig
            path="explore"
            referer={`${experiment}_B`}
            canonicalUrl="https://www.depop.com/"
          />
          <HomeHeader action={onStoreButtonClick} />
        </Variant>
      </Experiment>
    );
  }

};

const mapStateToProps = ({ abId }) => ({
  abId
});

const mapDispatchToProps = (dispatch) => ({
  updateAB: (value) => dispatch(updateLandingAB(value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HomeAB);



// WEBPACK FOOTER //
// ../src/client/apps/root/components/HomeAB.js